import request from '@/http/request'
import {
  getUserExtInfo,
  addStudentExt,
  UpdateRegistrationExt,
  selectOneSignUpExt,
  uploadExt,
  selectListExt,
  planStudentImportExt,
  studentExportExt,
  excelTempCreateExt,
  examineExtList,
  exportExamineExt,
  selectByOneInfo,
  examineNumber,
  getPlanCourse,
  getSignDateCountExt,
  uploadStationFiles,
  getStationFiles,
  saveStationFiles,
  deleteStationFiles,
  getAuditList,
  saveAuditFiles,
  cancelAuditFiles,
  exportAuditFiles,
  exportAuditFilesInfo,
  studentFilesUpload,
  planFileSetList,
  studentFilesList,
  studentFilesDelete,
  exportStudentFiles,
  getStationFilesPlan,
  getStationFilesStation
} from '@/http/api'

export const getStationFilesStationAPI = (data) => {
  return request({
    url: getStationFilesStation,
    data,
  })
}

export const getStationFilesPlanAPI = (data) => {
  return request({
    url: getStationFilesPlan,
    data,
  })
}

export const exportStudentFilesAPI = (data) => {
  return request({
    url: exportStudentFiles,
    data,
  })
}

export const studentFilesDeleteAPI = (data) => {
  return request({
    url: studentFilesDelete,
    data,
  })
}

export const studentFilesListAPI = (data) => {
  return request({
    url: studentFilesList,
    data,
  })
}

export const planFileSetListAPI = (data) => {
  return request({
    url: planFileSetList,
    data,
  })
}

export const studentFilesUploadAPI = (data) => {
  return request({
    url: studentFilesUpload,
    data,
    isUpload: true,
  })
}

export const exportAuditFilesInfoAPI = (data) => {
  return request({
    url: exportAuditFilesInfo,
    data,
  })
}

export const exportAuditFilesAPI = (data) => {
  return request({
    url: exportAuditFiles,
    data,
  })
}

export const cancelAuditFilesAPI = (data) => {
  return request({
    url: cancelAuditFiles,
    data,
  })
}

export const saveAuditFilesAPI = (data) => {
  return request({
    url: saveAuditFiles,
    data,
  })
}

export const getAuditListAPI = (data) => {
  return request({
    url: getAuditList,
    data,
  })
}

export const deleteStationFilesAPI = (data) => {
  return request({
    url: deleteStationFiles,
    data,
  })
}

export const saveStationFilesAPI = (data) => {
  return request({
    url: saveStationFiles,
    data,
  })
}

export const getStationFilesAPI = (data) => {
  return request({
    url: getStationFiles,
    data,
  })
}

export const uploadStationFilesAPI = (data) => {
  return request({
    url: uploadStationFiles,
    data,
    isUpload: true,
  })
}

export const getUserExtInfoFN = () => {
  return request({
    url: getUserExtInfo,
  })
}
export const getPlanCourseList = (data) => {
  return request({
    url: getPlanCourse,
    data
  })
}
export const addStudentExtSet = (data) => {
  return request({
    url: addStudentExt,
    data
  })
}
export const UpdateRegistration = (data) => {
  return request({
    url: UpdateRegistrationExt,
    data
  })
}
export const getSignDateCount  = (data) => {
  return request({
    url : getSignDateCountExt ,
   data
  })
}
export const selectOneSignUp = (data) => {
  return request({
    url: selectOneSignUpExt,
    data
  })
}
export const uploadExtSet = (data) => {
  return request({
    url: uploadExt,
    isUpload: true,
    data
  })
}
export const selectList = (data) => {
  return request({
    url: selectListExt,
    data
  })
}
export const planStudentImport = (data) => {
  return request({
    url: planStudentImportExt,
    method: 'POST',
    isUpload: true,
    data
  })
}
export const studentExport = (data) => {
  return request({
    url: studentExportExt,
    method: 'POST',
    data
  })
}
export const excelTempCreate = (data) => {
  return request({
    url: excelTempCreateExt,
    method: 'POST',
    data
  })
}
export const examineList = (data) => {
  return request({
    url: examineExtList,
    method: 'POST',
    data
  })
}
export const exportExamine = (data) => {
  return request({
    url: exportExamineExt,
    method: 'POST',
    data
  })
}
export const selectByOne = (data) => {
  return request({
    url: selectByOneInfo,
    method: 'GET',
    data
  })
}
export const getExamineNumber = (data) => {
  return request({
    url: examineNumber,
    method: 'POST',
    data
  })
}
